import type { CSSObject } from '@emotion/react'
import { Color } from '@opallabs/gem'
import { WithRequiredTheme } from '@opallabs/lapidary'
import { fonts, fontSizes } from '@opallabs/pulsar'

type ContainerProps = WithRequiredTheme & {
  readOnly?: boolean
  minRows?: number
  maxRows?: number
  rowHeight?: number
}

type ContentProps = {
  textAlign: 'start' | 'center' | 'end'
}

export const editorContainer = ({
  theme,
  readOnly,
  minRows,
  maxRows,
  rowHeight,
}: ContainerProps): CSSObject => {
  const base: CSSObject = {
    backgroundColor: Color[theme].Surface.N000,
    color: Color[theme].Text.Default,
    borderRadius: '3px',
    display: 'inline-block',
    inlineSize: '100%',
    position: 'relative',
    fontFamily: fonts.sansSerif,
    fontSize: fontSizes.medium,
    fontWeight: 400,
    lineHeight: `${fontSizes.xxLarge}px`,
    maxBlockSize:
      maxRows && rowHeight != null ? maxRows * rowHeight : 'initial',
    minBlockSize:
      minRows && rowHeight != null ? minRows * rowHeight : 'initial',
  }

  const editable: CSSObject = {
    ':hover': {
      backgroundColor: Color[theme].Surface.N200,
    },
  }

  return {
    ...base,
    ...(!readOnly ? editable : {}),
  }
}

export const editorContent = ({ textAlign }: ContentProps): CSSObject => {
  let placeholderPosition: CSSObject = { float: 'inline-start' }
  if (textAlign === 'end') {
    placeholderPosition = { float: 'inline-end' }
  } else if (textAlign === 'center') {
    placeholderPosition = {
      position: 'absolute',
      transform: 'translateX(-50%)',
    }
  }

  return {
    padding: '5px',
    minBlockSize: 'inherit',
    maxBlockSize: 'inherit',
    fontFamily: 'inherit',
    fontSize: 'inherit',
    fontWeight: 'inherit',
    lineHeight: 'inherit',
    textAlign,

    '&:hover': {
      cursor: 'text',
    },

    'p.is-editor-empty:first-of-type::before': placeholderPosition,

    p: {
      margin: 0,
    },

    '.social-link-match': {
      color: '#003569',
    },
    '.text-over-limit': {
      backgroundColor: '#FC8990',
    },
  }
}
